// this file is NOT generated
import { z } from 'zod';
import { events } from './event';

export const extensionEventSchema = z.enum(events);
